import getWindow from "../../utils/window";
import { getCommons, getGlobalEvars } from "../common";

export const getSeeSimilarCarouselTrackingValues = () => {
  const s = getWindow().s;
  const commons = getCommons();

  s.eVar60 = "styled for you - similar items";
  s.eVar61 = "styled for you - similar items";
  s.prop6 = "styled for you - out of stock product";
  s.tl(true, "o", "similar items carousel display", {
    linkTrackVars: commons.setLinkTrackVars([...getGlobalEvars(), "prop6"]),
  });
};
